import {FIND_USER} from "../../routes";
import customAxios from "../../customAxios";
import {IFindUserInformation} from "../../../types/common.interface";

async function getAllSchool(props: IFindUserInformation) {
  var thisUrl = FIND_USER + "?";
  if (props.page) thisUrl += `page=${props.page}`;
  if (props.limit) thisUrl += `&limit=${props.limit}`;

  const populateFields =
    "userTypes avatar balance blocks superAgentInformation.superAgentName balance financial.shabaNumber financial.kartNumber superAgentInformation.address superAgentInformation.nationalCode superAgentInformation.travelGroup superAgentInformation.financialGroup superAgentInformation.code superAgentInformation.province superAgentInformation.city";

  thisUrl += `&populate=${populateFields}`;

  let body: any = {
    query: {
      userTypes: {
        $in: ["SCHOOL"],
      },
    },
  };

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({GET_ALL_SCHOOL: error});
  }
}

export default getAllSchool;
